import { render, staticRenderFns } from "./goods-detail.vue?vue&type=template&id=579ecc3f&scoped=true&"
import script from "./goods-detail.vue?vue&type=script&lang=js&"
export * from "./goods-detail.vue?vue&type=script&lang=js&"
import style0 from "./goods-detail.vue?vue&type=style&index=0&id=579ecc3f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579ecc3f",
  null
  
)

export default component.exports